import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  date: string;
}

export const useGenerateDailyReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ date }: HookProps) => {
      const result = await apiClient.declarationsReports.generateDailyReport.mutation({
        body: { date },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
